import styled from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div`
  position: relative;

  span {
    width: 160px;

    /* O default era #ff9000 com tinta #312e38 — nunca renderizava, porque o
       unico consumidor (o erro de campo do Input) sobrescrevia os dois. Duas
       cores orfas mantidas vivas por um caminho morto. Como este componente
       so existe para mensagem de erro, o default agora e a propria cor de
       erro do sistema, e o consumidor nao precisa mais repeti-la. */
    background: ${tokens.color.errorRed};
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    opacity: 0;
    transition: opacity 0.3s;

    /* Sem 'visibility: hidden' de proposito. Ele removeria o texto da arvore
       de acessibilidade, e esta mensagem e a unica descricao do erro de
       validacao — precisa continuar legivel por leitor de tela mesmo quando
       esta visualmente escondida. 'pointer-events' faz o trabalho que a
       visibilidade fazia: nao capturar mouse enquanto invisivel. */
    pointer-events: none;

    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%);

    color: ${tokens.color.textWhite};

    &::before {
      content: '';
      border-style: solid;
      border-color: ${tokens.color.errorRed} transparent;
      border-width: 6px 6px 0 6px;
      top: 100%;

      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  &:hover span,
  &:focus-within span {
    opacity: 1;
    pointer-events: auto;
  }
`;
